import { brokersFieldLimits } from "@/Shared/Brokers/Helpers/brokersFieldLimits";
import ContactsLargeContactInput from "@/Shared/Contacts/Inputs/ContactsLargeContactInput";
import type { AddContactContactType } from "@/Shared/Types/contactTypes";
import {
  EmailRequired,
  contactsErrorMessagesForContact,
} from "@/Shared/Contacts/Validators/contactsErrorMessagesForContact";
import { useState } from "react";
import { Button } from "@freightsimple/ui-core/Controls/Button";
import { Row } from "@freightsimple/ui-core/ComponentLayout/Row";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";

interface AddContactPageProps {
  contact: AddContactContactType;
  contactChanged: (_: AddContactContactType) => void;
  onDone: () => void;
  onPrevious: () => void;
}
function BrokersAddBrokerDialogContactPage(props: AddContactPageProps) {
  const { contact, contactChanged, onPrevious, onDone } = props;
  const [forceValidation, setForceValidation] = useState(false);
  const errorMessages = contactsErrorMessagesForContact(
    contact,
    EmailRequired.EmailRequired,
  );

  function isValid() {
    if (
      errorMessages.contactName ||
      errorMessages.emailAddress ||
      errorMessages.phoneNumber
    ) {
      return false;
    } else {
      return true;
    }
  }

  async function onNext() {
    if (!isValid()) {
      setForceValidation(true);
      return;
    }

    onDone();
  }

  return (
    <Stack gap={8}>
      <ContactsLargeContactInput
        contact={contact}
        contactChanged={contactChanged}
        forceValidation={forceValidation}
        errorMessages={errorMessages}
        maxLengths={brokersFieldLimits}
      ></ContactsLargeContactInput>
      <Row justify="between">
        <Button onClick={onPrevious}>Previous</Button>
        <Button primary data-testid="save-broker-button" onClick={onNext}>
          Save
        </Button>
      </Row>
    </Stack>
  );
}
export default BrokersAddBrokerDialogContactPage;
